// @flow
import {
  Container,
  CssBaseline,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
};

const PaymentBack = (props: Props) => {
  const { t } = useTranslation();

  return (
    <Container component="main" maxWidth="xl">
      <CssBaseline/>
      <h1>{t('Your payment is processing')}</h1>
    </Container>
  );
};

export default PaymentBack;
